<router-outlet>
</router-outlet>

<ng-container *ngIf="modal">
<app-mobile-kamona-message-widget
  [isFullScreen]="true"
  [useDefaultBackground]="true"
  [useDefaultDialogBackdrop]="true"
  [modalType]="modalType">
  <ng-container *ngTemplateOutlet="lazyModuleLoader">
  </ng-container>
</app-mobile-kamona-message-widget>
</ng-container>

<ng-template #lazyModuleLoader>
  <div class="relative min-h-screen">
    <div class="vertically-centralized">
      <app-kamona-loading stroke="#FFFFFF" parentHeight="0" loadingType="SPINNER"></app-kamona-loading>
    </div>
  </div>
</ng-template>



